import { render, staticRenderFns } from "./SpesifikasiNonAktif.vue?vue&type=template&id=7f4a14a1&"
import script from "./SpesifikasiNonAktif.vue?vue&type=script&lang=js&"
export * from "./SpesifikasiNonAktif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports